import React from "react";
import AddChildModal from "../../components/Dashboard/AddChildModal";

const AddChildPage = () => {
  return <AddChildModal />;
};

export default AddChildPage;
